export const SECTIONS = {
  PRODUCTS           : 'Products',
  SEARCH_SUGGESTIONS : 'Search Suggestions',
  PAGES              : 'Pages',
  CONTENT            : 'Content',
} as const

export const SEARCH_FACET_ALLOWLIST = new Set(['cat1', 'cat2', 'cat3', 'cat4', 'manufacturer', 'promotions', 'pb', 'rating_summary'])

// How many terms the autocomplete request asks for from the Search Suggestions section. They
// lead the suggested-terms list, which related searches then top up — see mergeSuggestedTerms.
export const SEARCH_SUGGESTION_COUNT = 6

export const PODS = {
  SEARCH_DEFAULT        : 'preview-search',
  POPULAR_SEARCHES      : 'popular-searches',
  SIMILAR_ITEMS         : 'similar-items',
  RECOMMENDED_PRODUCTS  : 'recommended-products',
  CUSTOMERS_ALSO_BOUGHT : 'customers-also-bought',
  FIVE_FOR_FIVE         : '5-for-5',
  THREE_FREE            : '3-free',
  JUST_FOR_YOU          : 'just-for-you',
  ZERO_RESULTS          : 'zero-results',
} as const
